/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { OrderInvoiceItemViewModel } from "./OrderInvoiceItemViewModel";
import { SurveyAnswerInvoiceViewModel } from "./SurveyAnswerInvoiceViewModel";

export class OrderInvoiceViewModel {
    price: number | null;
    priceText: string;
    invoiceItems: OrderInvoiceItemViewModel[] = [];
    surveyAnswerInvoiceViewModels: SurveyAnswerInvoiceViewModel[];
}
